import React, { useState, useRef, useEffect } from "react";
import { getCSSRS } from "../services/soar";
import { getFieldDate, getFieldName } from "../../scripts/helperScripts";

function CSSRS({ contactID }) {
  const [expanded, setExpanded] = useState(false);
  const [cssrs, setCssrs] = useState([]);
  const isMountedRef = useRef(true);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  //Get Care Plans
  useEffect(() => {
    if (expanded) {
      console.log("Getting C-SSRS for ", contactID);
      getCSSRS(contactID).then((response) => {
        console.log("C-SSRS: ", response);
        if (isMountedRef.current) {
          if (response) {
            setCssrs(response);
          }

          setLoaded(true);
        }
      });
    } else setLoaded(true);
  }, [expanded]);

  useEffect(() => {
    setLoaded(false);
  }, [expanded]);

  const add = () => {
    const url =
      process.env.REACT_APP_ORG +
      "/main.aspx?etc=10518&extraqs=%3f_CreateFromId%3d" +
      contactID +
      "%26_CreateFromType%3d2%26etc%3d10518&histKey=457048345&newWindow=true&pagetype=entityrecord&navbar=off";
    window.open(url, "C-SSRS");
  };

  const openCSSRS = (id) => {
    const url = `${process.env.REACT_APP_ORG}/main.aspx?etc=10518&extraqs=formid%3d9185393a-be1f-4630-ad32-0fdce6f080c8&id=${id}&pagetype=entityrecord&navbar=off`;
    window.open(url, "C-SSRS");
  };

  return (
    <div className="border p-2 mb-4 card-safy">
      <div className="h4">
        <i
          title="Edit"
          className={
            expanded
              ? "fas fa-chevron-up p-1 text-primary"
              : "fas fa-chevron-down p-1 text-primary"
          }
          onClick={() => setExpanded(!expanded)}
        ></i>
        C-SSRS
        <i
          title="Add"
          className="fas fa-plus-circle float-end p-1 text-primary"
          onClick={add}
        ></i>
      </div>
      {expanded &&
        (cssrs.length > 0 ? (
          cssrs.map((c) => (
            <div className="p-2 m-2 text-white bg-safy3-1 row">
              <div className="col">{getFieldDate(c.sor_date)}</div>
              <div className="col">{getFieldName(c.sor_timeframe)}</div>
              <div className="col">{c.sor_severity}</div>
              <i
                title="Edit"
                onClick={() => openCSSRS(c.sor_cssrssoarid)}
                className="fas fa-pen float-end p-1"
              ></i>
            </div>
          ))
        ) : loaded === true ? (
          <div>No CSSRS records for client</div>
        ) : (
          <div>Loading</div>
        ))}
    </div>
  );
}

export default CSSRS;
